var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders-view-wrapper"},[(_vm.isOperator)?_c('orders-operator',{on:{"data-ready":_vm.restoreScroll}}):_c('orders',{on:{"data-ready":_vm.restoreScroll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }